import { Link } from "gatsby"
import React from "react"

import cellStyles from './cell_styles.module.scss'


const LinkDisplay= ({ children, linkType, nodeData }) => {

    // wrapper for wrapping TDs in a link //

    if (linkType === 'team') {

        // if season is before 2009, we wont have a page, so send to 2009 //
        if (parseInt(nodeData['season']) >= 2009) {
            return (

                <Link
                    className={cellStyles.linkOuter}
                    to={`../teams/${nodeData['team'].toLowerCase()}/${nodeData['season']}/`}
                >
                    <div className={cellStyles.linkInner}>
                        {children}
                    </div>
                </Link>

            )

        } else {
            return (

                children

            )
        }
    
    } else if (linkType === 'tendency') {

        if (parseInt(nodeData['season']) >= 2009) {
            return (

                <Link
                    className={cellStyles.linkOuter}
                    to={`../../teams/${nodeData['team'].toLowerCase()}/${nodeData['season']}/`}
                >
                    <div className={cellStyles.linkInner}>
                        {children}
                    </div>
                </Link>

            )

        } else {
            return (

                children

            )
        }
    
    } else if (linkType === 'wins') {

        if (parseInt(nodeData['season']) >= 2009) {
            return (

                <Link
                    className={cellStyles.linkOuter}
                    to={`../../teams/${nodeData['team'].toLowerCase()}/${nodeData['season']}/`}
                >
                    <div className={cellStyles.linkInner}>
                        {children}
                    </div>
                </Link>

            )
        } else {
            return (

                children
    
            )
        }
    
    } else {

        return (

            children

        )
    
    }

}

export default LinkDisplay